import { Package } from '../enums/package.enum'

export const isMinimumPackage = (userPackage: Package | null, targetPackage: Package, expiredAt: Date | null) => {
  if (!userPackage || (expiredAt == null)) {
    return false
  }

  if (new Date(expiredAt).valueOf() <= new Date().valueOf()) {
    return false
  }

  if (targetPackage === Package.START) {
    return true
  }

  if (targetPackage === Package.PLUS) {
    return userPackage === Package.PREMIUM || userPackage === Package.PLUS
  }

  if (targetPackage === Package.PREMIUM) {
    return userPackage === Package.PREMIUM
  }

  return false
}
